/**
 * 评估人选择器（评估报告 / 法务合规报告共用）
 *
 * 复用通用 UserSelect（MPC 用户管理库，姓名/邮箱模糊搜索，多选，只读态 POPOUserList）。
 * 之所以要做这层适配：SFormItem 的 render 回调拿不到表单注入的 value（value/onChange 由
 * SFormElementWrapper.SlotComponent 在 render 结果上 cloneElement 注入），而 UserSelect 是
 * 搜索驱动的 select —— options 不含已选项时 label 渲染不出来，必须由本组件把表单 value
 * 同时作为 prefillUsers 回灌，才能保证回显/已选人员的姓名正常展示。
 */
import React from 'react';
import UserSelect, { type UserSelectUser } from '@mpc/common/src/features/UserSelect';

/** 空数组常量：避免每次渲染新建引用，导致 UserSelect 的 prefill 副作用空跑 */
const EMPTY_USERS: UserSelectUser[] = [];

interface AssessorSelectProps {
  value?: UserSelectUser[] | null;
  onChange?: (value: UserSelectUser[] | UserSelectUser | null) => void;
  view?: boolean;
  disabled?: boolean;
}

const AssessorSelect: React.FC<AssessorSelectProps> = ({
  value,
  onChange,
  view,
  disabled,
}) => (
  <UserSelect
    multiple
    view={view}
    disabled={disabled}
    value={value ?? EMPTY_USERS}
    onChange={onChange}
    prefillUsers={value?.length ? value : EMPTY_USERS}
  />
);

export default AssessorSelect;
